export default __webpack_public_path__ + "static/media/referral-claim-desktop@3x.be565b80.png";